import React, { useMemo } from "react";
import Table from "../../../../../components/table";
import { useTranslation } from "react-i18next";
import { CellContext, ColumnDef } from "@tanstack/react-table";

import "./index.css";

export interface CustomFields {
    field: string
    value?: string
}
export interface CustomFieldsProps {
    custom: CustomFields[]
}

const Custom = ({ custom }: CustomFieldsProps) => {

  const { t } = useTranslation('translation', { keyPrefix: "customer.invoices.details.customFields" });

  const columns: ColumnDef<CustomFields>[] = useMemo(() => [{
    accessorKey: 'field',
    header: t('field') as string,
  }, {
    accessorKey: 'value',
    header: t('value') as string,
    cell: ({ row }: CellContext<CustomFields, unknown>) => {
      if(row.original.value) {
        if(typeof row.original.value !== "object") {
          return row.original.value;
        } else {
          return JSON.stringify(row.original.value)
        }
      }
    }
  }], [t]);

  if(!custom.length) {
    return null
  }

  return <div className="info-table with-shadow table">
    <div className="info-table-header">{t('title')}</div>
    <div className="info-table-body">
      <Table pageSize={5} data={custom} columns={columns} />
    </div>
  </div>
}

export default Custom;